// extracted by mini-css-extract-plugin
export var buttonWrapper = "mini-faq-hs-module--button-wrapper--31d14";
export var header = "mini-faq-hs-module--header--68a2d";
export var homeMiniFaq = "mini-faq-hs-module--home-mini-faq--4d650";
export var questions = "mini-faq-hs-module--questions--c76dc";